import React from "react";

import psmdocParser from "../utils/psmdocParser";

const extractHeaderMeta = (rawContent: string) => {
  const lines = String(rawContent || "").split(/\r?\n/);
  let firstLineIndex = 0;
  while (firstLineIndex < lines.length && lines[firstLineIndex].trim() === "") {
    firstLineIndex += 1;
  }
  const firstLine = lines[firstLineIndex] || "";
  if (!firstLine.trim().startsWith("##")) {
    return {
      title: null as string | null,
      label: null as string | null,
      content: rawContent,
    };
  }

  const header = firstLine.replace(/^##\s*/, "");
  const meta: { [key: string]: string } = {};
  const regex = /(\w+)\s*=\s*"([^"]*)"|(\w+)\s*=\s*'([^']*)'/g;
  let match;
  while ((match = regex.exec(header))) {
    const key = match[1] || match[3];
    const value = match[2] || match[4] || "";
    if (key) {
      meta[key] = value;
    }
  }

  const remainingLines = lines.slice(firstLineIndex + 1).join("\n");
  return {
    title: meta.title || null,
    label: meta.label || null,
    content: remainingLines,
  };
};

const psmdocPreview = ({
  content,
  title,
  projectConfig,
}: {
  content: string;
  title: string;
  projectConfig?: Record<string, any>;
}) => {
  const headerMeta = extractHeaderMeta(content || "");
  const displayTitle = headerMeta.title || title;
  const displayLabel = headerMeta.label || displayTitle;
  const config = projectConfig || {};
  const metaTitle = config.title || displayTitle;
  const metaDescription = config.description || "";
  const metaKeywords = config.keywords || "";
  const metaAuthor = config.author || "";
  const metaRobots = config.robots || "";
  const fontUrl = config.font || "";
  const styleConfig = config.style || {};
  const bodyStyle = Object.entries({
    background: styleConfig.background,
    color: styleConfig.color,
    "font-family": styleConfig["font-family"],
    "font-size": styleConfig["font-size"],
    "line-height": styleConfig["line-height"],
    "text-align": styleConfig["text-align"],
  })
    .filter(
      ([, value]) => value !== undefined && value !== null && value !== "",
    )
    .map(([key, value]) => `${key}:${value}`)
    .join(";");
  return `
        <!DOCTYPE html>
  <html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${metaTitle}</title>
    <meta name="description" content="${metaDescription}">
    <meta name="keywords" content="${metaKeywords}">
    <meta name="author" content="${metaAuthor}">
    <meta name="robots" content="${metaRobots}">
    ${fontUrl ? `<link rel="stylesheet" href="${fontUrl}">` : ""}
    <link rel="stylesheet" href="https://psmdoc.gestionciudad.com/djstatic/css/psmdoc.css">
  </head>
    <body style="${bodyStyle}">
      <main>       
        <div class="psm-mobile-menu" id="psm-mobile-menu">
          <div class="psm-mobile-menu-button">
            ☰ ${displayLabel} 
              
          </div>
          <div class="psm-mobile-menu-content">
            <ul>
                <li><a href="#top">Top</a></li>
                <li><a href="#content">Content</a></li>
                <li><a href="#footer">Footer</a></li>
            </ul>
          </div>
        </div>
        <header>
          <div class="psm-row">
            <!-- header -->
          </div>
        </header>
        <div class="psm-row">          
          <div class="psm-content">           
            
            ${psmdocParser(headerMeta.content)}
          </div>
          <div class="psm-sidebar">
            <h2>Menu</h2>
            <ul>
                <li><a href="#top">Top</a></li>
                <li><a href="#content">Content</a></li>
                <li><a href="#footer">Footer</a></li>
            </ul>
          </div>
        </div>
        <div class="psm-row">
          <!-- footer -->     
        </div>
      </main>
      <footer>
        <p>&copy; ${displayTitle} ${new Date().getFullYear()}</p>
      </footer>
    </body>
    <script src="https://psmdoc.gestionciudad.com/djstatic/js/psmdoc.js"></script>
  </html>`;
};

export default psmdocPreview;
